import LegalLayout from "@/components/LegalLayout";

/**
 * Privacy Policy per RecenUp — coerente 1:1 con il codebase reale (nessun
 * trattamento inventato). Le porzioni fra parentesi quadre `[DA COMPILARE]`
 * vanno completate dal Titolare prima del go-live pubblico.
 */
export default function Privacy() {
  return (
    <LegalLayout title="Informativa Privacy" updatedAt="Febbraio 2026">
      <p>
        La presente informativa descrive il trattamento dei dati personali
        effettuato da <strong>[DA COMPILARE: ragione sociale / persona fisica]</strong>
        (di seguito, "<strong>Titolare</strong>") tramite l'applicazione web
        RecenUp accessibile all'indirizzo{" "}
        <code>recenup.com</code> (l'"App"),
        ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 ("GDPR").
      </p>

      <h2>1. Titolare del trattamento</h2>
      <ul>
        <li><strong>Ragione sociale</strong>: [DA COMPILARE]</li>
        <li><strong>P.IVA / Codice Fiscale</strong>: [DA COMPILARE]</li>
        <li><strong>Sede legale</strong>: [DA COMPILARE]</li>
        <li><strong>Email di contatto Privacy</strong>: <a href="mailto:privacy@recenup.com">privacy@recenup.com</a></li>
        <li><strong>Responsabile della Protezione dei Dati (DPO)</strong>: non nominato (l'attività non rientra fra quelle per cui la nomina è obbligatoria ai sensi dell'art. 37 GDPR; valutazione soggetta a verifica legale)</li>
      </ul>

      <h2>2. Categorie di dati trattati</h2>
      <h3>2.1 Dati forniti direttamente dall'Utente</h3>
      <ul>
        <li><strong>Dati di registrazione</strong>: nome, cognome, indirizzo email, password (memorizzata in forma cifrata con algoritmo bcrypt — mai in chiaro).</li>
        <li><strong>Dati dell'attività (business)</strong>: nome commerciale, indirizzo, sito web, link Google Business Profile.</li>
        <li><strong>Dati contatto per NFC Card</strong> (in caso di acquisto): nome, cognome, indirizzo di spedizione, numero di telefono, email.</li>
      </ul>
      <h3>2.2 Dati generati dall'uso dell'App</h3>
      <ul>
        <li><strong>Log di accesso e sicurezza</strong>: indirizzo IP, timestamp, esiti di login/registrazione/reset password (memorizzati nella collection <code>security_events</code> a fini anti-frode e anti-brute-force).</li>
        <li><strong>Dati di sessione</strong>: cookie tecnico <code>session_token</code> (HttpOnly, Secure, SameSite=None, durata 7 giorni) contenente un identificatore casuale legato all'utente autenticato.</li>
        <li><strong>Preferenze UI</strong>: tema chiaro/scuro e stato "banner trial chiuso" salvati in <code>localStorage</code> del browser.</li>
        <li><strong>Attribuzione referral</strong>: codice referral eventualmente ricevuto tramite link di invito, salvato temporaneamente in <code>localStorage</code> per essere applicato alla registrazione.</li>
      </ul>
      <h3>2.3 Dati raccolti tramite integrazioni di terze parti (su iniziativa dell'Utente)</h3>
      <ul>
        <li><strong>Google Business Profile</strong> (se l'Utente collega il proprio account Google): email dell'account Google collegato, token OAuth (memorizzati cifrati con Fernet), elenco delle location di business ed elenco delle recensioni pubbliche associate.</li>
        <li><strong>Stripe</strong> (se l'Utente acquista NFC Card o attiva il piano Pro): dati di pagamento gestiti direttamente da Stripe secondo la sua informativa; l'App riceve solo l'esito della transazione e non registra mai il numero completo della carta.</li>
      </ul>
      <h3>2.4 Dati testuali inviati alle funzioni AI (solo utenti Pro / in Trial)</h3>
      <p>
        Le funzioni "AI Insights" e "AI Reply" inviano il <strong>testo delle recensioni</strong>{" "}
        e il nome dell'attività a un modello di intelligenza artificiale (Gemini 3.1 Pro, fornito
        da Google tramite l'infrastruttura Emergent) per generare sintesi e proposte di risposta.
        Nessun dato di contatto dell'Utente viene inviato al modello. Le richieste vengono
        registrate nella collection interna <code>ai_usage_ledger</code> a fini di quota e audit.
      </p>

      <h2>3. Base giuridica e finalità</h2>
      <table style={{ width: "100%", fontSize: "13px", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ borderBottom: "1px solid var(--border-c)" }}>
            <th style={{ textAlign: "left", padding: "8px 0" }}>Finalità</th>
            <th style={{ textAlign: "left", padding: "8px 0" }}>Base giuridica</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>Erogazione del servizio e autenticazione</td><td>Contratto (art. 6.1.b GDPR)</td></tr>
          <tr><td>Fatturazione, ricevute e adempimenti fiscali</td><td>Obbligo legale (art. 6.1.c GDPR)</td></tr>
          <tr><td>Sicurezza dell'App (rate-limit, log anti-frode)</td><td>Interesse legittimo (art. 6.1.f GDPR)</td></tr>
          <tr><td>Email transazionali (conferme ordine, ricevute, reminder trial, scheduled reports)</td><td>Contratto / interesse legittimo</td></tr>
          <tr><td>Sincronizzazione Google Business Profile</td><td>Consenso esplicito dell'Utente al momento del collegamento (art. 6.1.a GDPR)</td></tr>
          <tr><td>Funzioni AI (Insights, Reply, Scheduled Reports)</td><td>Contratto (Pro/Trial)</td></tr>
          <tr><td>Programma referral (attribuzione, credito)</td><td>Contratto (partecipazione al programma)</td></tr>
        </tbody>
      </table>

      <h2>4. Conservazione dei dati</h2>
      <ul>
        <li><strong>Account attivo</strong>: per tutta la durata del rapporto contrattuale.</li>
        <li><strong>Dopo la cancellazione dell'account</strong>: i dati vengono eliminati entro 30 giorni, fatti salvi obblighi legali (fatture, ricevute: 10 anni ex art. 2220 c.c.).</li>
        <li><strong>Log di sicurezza</strong>: 12 mesi.</li>
        <li><strong>Cookie di sessione</strong>: 7 giorni o fino al logout esplicito.</li>
        <li><strong>Token Google Business Profile</strong>: fino a revoca esplicita da parte dell'Utente (pulsante "Scollega Google").</li>
      </ul>

      <h2>5. Cookie e strumenti di tracciamento</h2>
      <p>
        RecenUp <strong>non utilizza cookie o strumenti di profilazione</strong>. Gli unici
        strumenti di memorizzazione client-side sono i seguenti, tutti classificati come
        strettamente necessari o funzionali:
      </p>
      <table style={{ width: "100%", fontSize: "13px", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ borderBottom: "1px solid var(--border-c)" }}>
            <th style={{ textAlign: "left", padding: "8px 0" }}>Nome</th>
            <th style={{ textAlign: "left", padding: "8px 0" }}>Tipo</th>
            <th style={{ textAlign: "left", padding: "8px 0" }}>Durata</th>
            <th style={{ textAlign: "left", padding: "8px 0" }}>Finalità</th>
          </tr>
        </thead>
        <tbody>
          <tr><td><code>session_token</code></td><td>Cookie HttpOnly</td><td>7 giorni</td><td>Autenticazione sessione</td></tr>
          <tr><td><code>recenup-theme</code></td><td>localStorage</td><td>Persistente</td><td>Preferenza tema chiaro/scuro</td></tr>
          <tr><td><code>trial-banner-*</code></td><td>localStorage</td><td>Persistente</td><td>Chiusura banner trial</td></tr>
          <tr><td><code>recenup-referral</code>, <code>recenup-referral-at</code></td><td>localStorage</td><td>Fino alla registrazione</td><td>Attribuzione referral</td></tr>
        </tbody>
      </table>
      <h3>5.1 Font web</h3>
      <p>
        I caratteri tipografici sono <strong>ospitati in locale</strong> sui nostri server e
        non generano richieste verso CDN di terze parti (es. Google Fonts): nessun dato è
        pertanto trasmesso a terzi per il rendering della UI.
      </p>
      <h3>5.2 Script tecnici della piattaforma di hosting</h3>
      <p>
        L'App è ospitata sulla piattaforma <strong>Emergent</strong>. In ambiente di anteprima
        (<code>*.preview.emergentagent.com</code>) può essere caricato uno script tecnico della
        piattaforma (<code>assets.emergent.sh/scripts/emergent-main.js</code>) necessario al
        funzionamento del preview. In ambiente di produzione su dominio proprio, tale script
        non viene caricato; la presente informativa sarà aggiornata qualora dovesse
        risultare presente. Per informazioni sul trattamento operato da Emergent Labs si
        rinvia alla loro informativa privacy.
      </p>

      <h2>6. Destinatari dei dati (sub-processor)</h2>
      <p>
        Il Titolare si avvale dei seguenti responsabili del trattamento, tutti selezionati
        per l'affidabilità e la conformità alle norme sulla protezione dei dati:
      </p>
      <ul>
        <li><strong>Emergent Labs Inc.</strong> — hosting dell'App, invio email transazionali (via Resend), infrastruttura AI (via provider Gemini di Google).</li>
        <li><strong>Stripe Payments Europe Ltd.</strong> — elaborazione pagamenti (NFC Card, abbonamento Pro).</li>
        <li><strong>Google LLC / Google Ireland Ltd.</strong> — solo su iniziativa dell'Utente che collega il proprio account Google Business Profile.</li>
        <li><strong>MongoDB Inc.</strong> — database applicativo.</li>
      </ul>
      <p>
        Alcuni fornitori possono avere sede negli Stati Uniti; in tali casi i trasferimenti
        avvengono sulla base delle Standard Contractual Clauses (SCC) della Commissione
        Europea e/o dei framework di adeguatezza (Data Privacy Framework EU-US).
      </p>

      <h2>7. Diritti dell'interessato</h2>
      <p>
        In qualsiasi momento l'Utente può esercitare i diritti previsti dagli artt. 15-22
        GDPR scrivendo a <a href="mailto:privacy@recenup.com">privacy@recenup.com</a>:
      </p>
      <ul>
        <li>Accesso ai propri dati (art. 15)</li>
        <li>Rettifica (art. 16)</li>
        <li>Cancellazione / "diritto all'oblio" (art. 17)</li>
        <li>Limitazione del trattamento (art. 18)</li>
        <li>Portabilità (art. 20) — l'App permette l'export in CSV/PDF delle recensioni</li>
        <li>Opposizione (art. 21)</li>
        <li>Revoca del consenso prestato — quando il trattamento si fonda sul consenso, senza pregiudicare la liceità del trattamento antecedente</li>
      </ul>
      <p>
        È inoltre riconosciuto il diritto di proporre reclamo al Garante per la Protezione
        dei Dati Personali (<a href="https://www.garanteprivacy.it/" target="_blank" rel="noreferrer">garanteprivacy.it</a>).
      </p>

      <h2>8. Sicurezza</h2>
      <ul>
        <li>Password degli utenti memorizzate solo come hash bcrypt.</li>
        <li>Token OAuth di Google Business Profile cifrati a riposo con algoritmo Fernet (AES-128 CBC + HMAC-SHA256).</li>
        <li>Rate-limiting su login, registrazione e recupero password per contrastare attacchi brute-force.</li>
        <li>Comunicazioni cifrate in transito via TLS.</li>
        <li>Accesso ai dati riservato al personale autorizzato del Titolare.</li>
      </ul>

      <h2>9. Modifiche</h2>
      <p>
        La presente informativa può essere aggiornata per riflettere modifiche legali o
        funzionali dell'App. La data di ultimo aggiornamento è indicata in cima al
        documento; nel caso di modifiche sostanziali gli Utenti registrati saranno
        informati via email.
      </p>
    </LegalLayout>
  );
}
